
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    nr: String,
  },
});
